import React from 'react';
import BaseComponent from "../../base-component/base-component";

import Popover from '../../gd-popover/popover-v2';
import PopoverPosition from '../../gd-popover/popover-position';
import {PopoverAttachmentType} from '../../gd-popover/@const';

export default class PopoverHint extends BaseComponent {

    onMouseEnter = () => {
        // prevent hint from closing i.e. slow mouse move
        if (this.props.userIcon.debounceHideHint) this.props.userIcon.debounceHideHint.cancel();
    };

    onMouseLeave = () => {
        this.props.userIcon.onMouseLeave();
    };

    onHintClick = () => {
        this.props.userIcon._hidePopover();

        const { onClick } = this.props;
        if (onClick) onClick();
    };

    goToUser = () => {
        const { userIcon } = this.props;
        const companyUser = gd.session.companyUsers.get(gd.companyId+"-"+userIcon.props.userId);

        if (companyUser) {
            gd.goTo('u/'+gd.companyId+"-"+userIcon.props.userId);
        }
    };

    render() {
        const { userIcon } = this.props;
        const user = gd.session.users.get(userIcon.props.userId);

        if (!user) return false

        // default
        let attachment="top center";
        let targetAttachment="bottom center";
        let attachmentType=PopoverAttachmentType.HORIZONTAL;


        switch (userIcon.props.hint) {

            case 'top':
                attachment="bottom center";
                targetAttachment="top center";
                attachmentType=PopoverAttachmentType.HORIZONTAL;
                break;

            case 'right':
                attachment="middle left";
                targetAttachment="middle right";
                attachmentType=PopoverAttachmentType.VERTICAL;
                break;

            case 'left':
                attachment="middle right";
                targetAttachment="middle left";
                attachmentType=PopoverAttachmentType.VERTICAL;
                break;

            case 'bottom':
                attachment="top center";
                targetAttachment="bottom center";
                attachmentType=PopoverAttachmentType.HORIZONTAL;
                break;

            case true:
                // default
                break;

        }

        // SVEHU PO CENTRU
        // attachment="bottom center"
        // targetAttachment="top center"
        // attachmentType="horizontal"

        // SNIZU PO CENTRU
        // attachment="top center"
        // targetAttachment="bottom center"
        // attachmentType="horizontal"

        // SPRAVA
        // attachment="middle left"
        // targetAttachment="middle right"
        // attachmentType="vertical"

        // SLEVA
        // attachment="middle right"
        // targetAttachment="middle left"
        // attachmentType="vertical"


        // <div className="i5-big-angle-right" onClick={this.goToUser}></div>

        const companyUser = gd.session.companyUsers.get(gd.companyId+"-"+userIcon.props.userId);
        const departmentName = (companyUser && gd.session.departments.filterByCompany(gd.companyId).length>1)?gd.session.departments.get(companyUser.departmentId).name:false;

        const popoverPosition = new PopoverPosition({
            attachment,
            targetAttachment,
            attachmentType,
        })

        return (
            <Popover className="gd-popover-hint"
                     getTargetFunc={this.props.getTargetFunc}
                     targetClass="gd-user"
                     constraints={[{
                         to: 'window',
                         attachment: 'together',
                         pin: true
                     }]}
                     position={popoverPosition}>
                <div className="hint-container user" onClick={this.onHintClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    <div className="name">{user.name}</div>
                    {companyUser && <div className="desc">{departmentName}</div>}
                    <div className="i5-big-angle-right" onClick={this.goToUser}> </div>
                </div>
            </Popover>
        );
    }
}
